import { FusePerfectScrollbarDirective } from "admin/@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive";
import { FuseNavigation } from "admin/@fuse/types";
import { UserPermission } from "admin/appModel/Company";
import { Constants } from "admin/appModel/Constants";
import { BehaviorSubject } from "rxjs";

export abstract class AppService {
    abstract onSetSidebarHidden: BehaviorSubject<boolean>;
    abstract scrollbar: FusePerfectScrollbarDirective;
    abstract ScrollTo(x: number, y: number, speed?: number): void;

    abstract get AppConstants(): Constants;
    abstract get UserId(): number;
    abstract get CompanyId(): number;
    abstract get IsAgent(): boolean;
    abstract get AgentId(): number;
    abstract get IsOwner(): boolean;

    abstract LoadConstants(): Promise<void>;
    abstract LoadPermissions(): Promise<boolean>;

    abstract InitNavigation(nav: FuseNavigation[]): Promise<void>;
    abstract RefreshNavigation(): Promise<void>;

    abstract HasPermission(section: string, permission: UserPermission): boolean;
}